import { render, staticRenderFns } from "./buildbyoneself.vue?vue&type=template&id=f196e88e&scoped=true&"
import script from "./buildbyoneself.vue?vue&type=script&lang=js&"
export * from "./buildbyoneself.vue?vue&type=script&lang=js&"
import style0 from "./buildbyoneself.vue?vue&type=style&index=0&id=f196e88e&lang=scss&scoped=true&"
import style1 from "./buildbyoneself.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f196e88e",
  null
  
)

export default component.exports